import { SpecsView } from "@/admin/metal/specs/SpecsView.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/admin/_menu/_simple/metal/specs")({
    component: SpecsView,
});
